import * as actionTypes from '../constants/action-types';
import { groupBy } from '../helpers/common';

const initialState = {
    statusList: [
        { statusName: 'Active', statusId: 1 },
        { statusName: 'Locked', statusId: 2 }
    ],
    farmList: {
        isRequesting: false,
        payload: []
    },
    userListById: {
        isRequesting: false,
        isRequestingAuthList: false,
        payload: {}
    },
    authProviderListById: {
        isRequesting: false,
        payload: {}
    },
    roleListById: {
        isRequesting: false,
        isRequestingPermission: false,
        payload: {}
    },
    controllerListById: {
        isRequesting: false,
        payload: {}
    }
};

export default (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.USER_GET_ROLE_LIST_REQUEST: {
            state = {
                ...state,
                roleListById: {
                    ...state.roleListById,
                    isRequesting: true,
                    payload: {}
                }
            };
            break;
        }
        case actionTypes.USER_GET_ROLE_LIST: {
            const payload = action.payload ? action.payload : [];

            const roleListById = {};
            payload.forEach(item => roleListById[item.role_id] = item);

            state = {
                ...state,
                roleListById: {
                    ...state.roleListById,
                    isRequesting: false,
                    payload: roleListById
                }
            };
            break;
        }
        case actionTypes.USER_GET_FARM_LIST_REQUEST: {
            state = {
                ...state,
                farmList: {
                    isRequesting: true,
                    payload: []
                }
            };
            break;
        }
        case actionTypes.USER_GET_FARM_LIST: {
            state = {
                ...state,
                farmList: {
                    isRequesting: false,
                    payload: action.payload ? action.payload : []
                }
            };
            break;
        }
        case actionTypes.USER_LIST_REQUEST: {
            state = {
                ...state,
                userListById: {
                    isRequesting: true,
                    payload: {}
                }
            };
            break;
        }
        case actionTypes.USER_GET_USER_LIST: {
            let userListById = {};
            action.payload && action.payload.forEach(item => { userListById[item.user_id] = item });
            state = {
                ...state,
                userListById: {
                    isRequesting: false,
                    payload: userListById
                }
            };
            break;
        }
        case actionTypes.USER_GET_AUTH_PROVIDER_LIST_REQUEST: {
            state = {
                ...state,
                authProviderListById: {
                    isRequesting: true,
                    payload: {}
                }
            };
            break;
        }
        case actionTypes.USER_GET_AUTH_PROVIDER_LIST: {
            const payload = action.payload ? action.payload : [];

            const authProviderListById = {};
            payload.forEach(item => authProviderListById[item.authentication_provider_id] = item);

            state = {
                ...state,
                authProviderListById: {
                    isRequesting: false,
                    payload: authProviderListById
                }
            };
            break;
        }
        case actionTypes.USER_GET_AUTH_LIST_REQUEST: {
            state = {
                ...state,
                userListById: {
                    ...state.userListById,
                    isRequestingAuthList: true
                }
            };
            break;
        }
        case actionTypes.USER_GET_AUTH_LIST: {
            const payload = action.payload ? action.payload : [];

            const userListById = { ...state.userListById.payload };
            const groupId = groupBy("user_id")(payload);

            Object.keys(userListById).forEach(id => {
                userListById[id] = { ...userListById[id], authList: groupId[id] ? groupId[id] : [] }
            });

            state = {
                ...state,
                userListById: {
                    ...state.userListById,
                    isRequestingAuthList: false,
                    payload: { ...userListById }
                }
            };
            break;
        }
        case actionTypes.USER_GET_USER_FARM_LIST_REQUEST: {
            const { userId } = action;
            if (!userId) break;

            state = {
                ...state,
                userListById: {
                    ...state.userListById,
                    payload: {
                        ...state.userListById.payload,
                        [userId]: {
                            ...state.userListById.payload[userId],
                            isRequestingAssignedFarm: true,
                            assignedFarmIds: []
                        }
                    }
                }
            }
            break;
        }
        case actionTypes.USER_GET_USER_FARM_LIST: {
            const { userId, payload } = action;
            if (!userId) break;

            state = {
                ...state,
                userListById: {
                    ...state.userListById,
                    payload: {
                        ...state.userListById.payload,
                        [userId]: {
                            ...state.userListById.payload[userId],
                            isRequestingAssignedFarm: false,
                            assignedFarmIds: payload ? payload : []
                        }
                    }
                }
            }
            break;
        }
        case actionTypes.USER_GET_ROLE_PERMISSION_LIST_REQUEST: {
            state = {
                ...state,
                roleListById: {
                    ...state.roleListById,
                    isRequestingPermission: true,
                }
            };
            break;
        }
        case actionTypes.USER_GET_ROLE_PERMISSION_LIST: {
            const payload = action.payload ? action.payload : [];
            const roleListById = { ...state.roleListById.payload };

            payload.forEach(item => {
                const permissionById = {};
                item.controller && item.controller.forEach(e => permissionById[e.controller_id] = e.permission);

                roleListById[item.role_id] = {
                    ...roleListById[item.role_id],
                    permission: permissionById
                }
            });

            state = {
                ...state,
                roleListById: {
                    ...state.roleListById,
                    isRequestingPermission: false,
                    payload: roleListById
                }
            };
            break;
        }
        case actionTypes.USER_GET_CONTROLLER_LIST_REQUEST: {
            state = {
                ...state,
                controllerListById: {
                    ...state.controllerListById,
                    isRequesting: true,
                }
            };
            break;
        }
        case actionTypes.USER_GET_CONTROLLER_LIST: {
            const payload = action.payload ? action.payload : [];

            const controllerListById = {};
            payload.forEach(item => controllerListById[item.controller_id] = item);

            state = {
                ...state,
                controllerListById: {
                    isRequesting: false,
                    payload: controllerListById
                }
            };
            break;
        }
        case actionTypes.USER_UPDATE_ROLE_PERMISSION: {
            if (!action.payload) break;
            const { role_id, controller_id, enable, action_id } = action.payload;

            if (!(role_id && controller_id && action_id)) break;

            const roleListById = { ...state.roleListById.payload };

            const getActionList = (list) => {
                let actionList = [...list];
                if (enable && actionList.indexOf(action_id) < 0)
                    actionList.push(action_id);
                else if (!enable && actionList.indexOf(action_id) >= 0)
                    actionList.splice(actionList.indexOf(action_id), 1);
                return actionList;
            };

            roleListById[role_id] = {
                ...roleListById[role_id],
                permission: {
                    ...roleListById[role_id].permission,
                    [controller_id]: getActionList(roleListById[role_id].permission[controller_id])
                },
            };

            state = {
                ...state,
                roleListById: {
                    ...state.roleListById,
                    payload: roleListById
                }

            };
            break;
        }
        case actionTypes.USER_GET_USER_PERMISSION_REQUEST: {
            const { userId } = action;
            if (!userId) break;

            state = {
                ...state,
                userListById: {
                    ...state.userListById,
                    payload: {
                        ...state.userListById.payload,
                        [userId]: {
                            ...state.userListById.payload[userId],
                            isRequestingPermission: true
                        }
                    }
                }
            }
            break;
        }
        case actionTypes.USER_GET_USER_PERMISSION: {
            if (!action.userId) break;
            const permissionById = {};
            action.payload && action.payload.controller.forEach(e =>
                permissionById[e.controller_id] = e.permission);

            state = {
                ...state,
                userListById: {
                    ...state.userListById,
                    payload: {
                        ...state.userListById.payload,
                        [action.userId]: {
                            ...state.userListById.payload[action.userId],
                            isRequestingPermission: false,
                            ...action.payload && { permission: permissionById }
                        }
                    }

                }
            }
            break;
        }

        case actionTypes.USER_UPDATE_USER_PERMISSION: {
            if (!action.payload) break;

            const { user_id, controller_id, enable, action_id } = action.payload;
            if (!(user_id && controller_id && action_id)) break;

            const userListById = { ...state.userListById.payload };
            const oldPermissionList = userListById[user_id].permission[controller_id];

            const getActionList = (list) => {
                let actionList = [...list];
                if (enable && actionList.indexOf(action_id) < 0)
                    actionList.push(action_id);
                else if (!enable && actionList.indexOf(action_id) >= 0)
                    actionList.splice(actionList.indexOf(action_id), 1);
                return actionList;
            };

            state = {
                ...state,
                userListById: {
                    ...state.userListById,
                    payload: {
                        ...state.userListById.payload,
                        [user_id]: {
                            ...state.userListById.payload[user_id],
                            permission: {
                                ...state.userListById.payload[user_id].permission,
                                [controller_id]: getActionList(oldPermissionList)
                            },
                        }
                    }
                }
            }
            break;
        }
        default:
            break;
    }
    return state;
};